export const clearFormState = (formState) => {
    for (const key in formState) {
        if (Array.isArray(formState[key])) {
            formState[key] = [];
        } else if (typeof formState[key] === 'string') {
            formState[key] = '';
        } else {
            formState[key] = null;
        }
    }
}

export const formatTimeOnSite = (avgTime) => {
    const avgTimeOnSite = Number(avgTime);
    if (typeof avgTimeOnSite !== 'number' || avgTimeOnSite < 0) {
        throw new Error('avgTimeOnSite 必须是一个非负数字');
    }
    const hours = Math.floor(avgTimeOnSite / 3600);
    const minutes = Math.floor((avgTimeOnSite % 3600) / 60);
    const seconds = avgTimeOnSite % 60;
    if (hours > 0) {
        // 如果小时数大于0，则显示小时、分钟和秒
        return `${String(hours).padStart(2, '0')}时${String(minutes).padStart(2, '0')}分${String(seconds).padStart(2, '0')}秒`;
    } else {
        // 如果小时数为0，则只显示分钟和秒
        return `${String(minutes).padStart(2, '0')}分${String(seconds).padStart(2, '0')}秒`;
    }
}


export const parseTimeStringToSeconds = (timeString) => {
    // 正则表达式匹配时间字符串中的小时、分钟和秒
    const regex = /(?:(\d+)时)?(?:(\d+)分)?(\d+)秒/;
    const match = timeString.match(regex);

    if (!match) {
        throw new Error('时间格式不正确');
    }

    // 提取并解析小时、分钟和秒
    const hours = (match[1] ? parseInt(match[1], 10) : 0);
    const minutes = (match[2] ? parseInt(match[2], 10) : 0);
    const seconds = parseInt(match[3], 10);

    // 计算总秒数
    return hours * 3600 + minutes * 60 + seconds;
}


export const cleanAndReplaceAlias = (alias) => {
    // 条件1：严格全等 '/' 时，不做任何处理，原样返回 '/'
    if (alias === '/') {
        return '/';
    }
    // 条件2：alias为 undefined/null/空值 等无效值，直接返回 空字符串''
    if (!alias) {
        return '';
    }
    // 条件3：其余所有有效值，执行原有清洗逻辑
    let cleanedAlias = alias.toLowerCase();
    cleanedAlias = cleanedAlias.replace(/[^a-z0-9\u4e00-\u9fff]/g, '-');
    cleanedAlias = cleanedAlias.replace(/-+/g, '-');
    cleanedAlias = cleanedAlias.replace(/^-|-$/g, '');
    return cleanedAlias;
};

// 封装方法  案例: '1,2,3'  [treedata树形结构数据] =>输出结果[{value: item.id, label: item.name},...] 最终方案（兼顾可读性和性能）
export function findObjects(data, ids) {
    const idSet = new Set(ids);
    const results = [];
    const stack = [...data];

    while (stack.length) {
        const { id, name, childlist } = stack.pop();
        if (idSet.has(id)) results.push({ value: id, label: name });
        if (childlist?.length) stack.push(...childlist);
    }
    return results;
}

// 封装方法  案例: '1,2,3'  [treedata树形结构数据] =>输出结果'name,name2...'

export function getNames(treeData, idList) {
    if (!treeData || !idList) return '';
    const ids = String(idList)
        .split(',')
        .map(id => id.trim())
        .filter(Boolean);
    if (ids.length === 0) return '';

    const idToNameMap = {};
    function buildMap(nodes) {
        nodes.forEach(node => {
            const key = String(node.id);
            idToNameMap[key] = node.name;
            if (node.childlist && Array.isArray(node.childlist)) {
                buildMap(node.childlist);
            }
        });
    }
    buildMap(treeData);

    const names = ids.map(id => idToNameMap[id] || '');
    return names.filter(Boolean).join(',');
}


export function replaceNullWithEmptyString(array) {
    return array.map((obj) => {
        if ("value" in obj && obj.value === null) {
            return { ...obj, value: "" };
        }
        return obj;
    });
}

export function processData(data) {
    return data.map(item => {
        // 1. 提取日期键并按时间排序
        const sortedDates = Object.keys(item).filter(val => val !== 'count' && val !== 'domain' && val !== 'keyword').sort()
        // 2. 收集所有有效点（非'--'的值）及其索引
        const validPoints = [];
        sortedDates.forEach((date, index) => {
            const value = item[date];
            if (value !== '--') {
                validPoints.push({ index, value: value });
            }
        });

        // 3. 处理每个日期
        const newObj = { ...item }; // 保留原始的非日期字段
        sortedDates.forEach((date, currentIndex) => {
            const originalValue = item[date];

            // 非'--'值直接保留
            if (originalValue !== '--') {
                newObj[date] = originalValue;
            } else {
                // 没有有效点则保留'--'
                if (validPoints.length === 0) {
                    newObj[date] = '--';
                    return;
                }

                // 寻找最近的有效点（距离最小）
                let closestPoint = null;
                let minDistance = Infinity;

                validPoints.forEach(point => {
                    const distance = Math.abs(currentIndex - point.index);
                    // 找到距离更近的点，或者距离相同但更靠后的点
                    if (distance < minDistance ||
                        (distance === minDistance && point.index > closestPoint?.index)) {
                        minDistance = distance;
                        closestPoint = point;
                    }
                });

                // 用最近的有效点值填充
                newObj[date] = closestPoint.value;
            }
        });

        return newObj;
    });
}
export const getAllChildIds = (node) => {
    let ids = [];
    if (node.childlist && node.childlist.length) {
        node.childlist.forEach(child => {
            ids.push({ 'label': child.name, 'value': child.id });
            if (child.childlist) {
                ids = [...ids, ...getAllChildIds(child)];
            }
        });
    }
    return ids;
};

// 辅助函数：递归获取所有子节点的id

export const flattenChildrenKeys = (childlist) => {
    return childlist.reduce((keys, child) => {
        keys.push(child.id);
        if (child.childlist && child.childlist.length > 0) {
            keys = keys.concat(flattenChildrenKeys(child.childlist));
        }
        return keys;
    }, []);
};
export function findNode(menuData, targetId) {
    for (const item of menuData) {
        // 检查当前项
        if (item.id === targetId) {
            return item;
        }
        // 递归检查子项
        if (item.children?.length) {
            const found = findNode(item.children, targetId);
            if (found) return found;
        }
    }
    return null;
}

export function processAndFormatPath(path) {
    // 额外特殊规则：针对特定路径返回固定值
    if(path.includes('/article')) {
        if(path.includes('/article/edit/') || path.includes('/article/add/')) return 'articleAddArticle'
        return 'article'
    }else {
        const pathArray = Array.isArray(path) ? path : (path ? path.split('/') : []);
        return pathArray
            .filter(segment => segment) // 过滤空字符串
            .map((segment, index) => {
                if (index === 0) {
                    return segment.toLowerCase(); // 第一个片段全小写
                } else {
                    // 后续片段首字母大写，其余小写
                    return segment.charAt(0).toUpperCase() + segment.slice(1).toLowerCase();
                }
            })
            .join('');
    }

}